<template>
  <section
    class="px-2 pt-2 sm:px-10 sm:pt-10 flow-root bg-main-bg h-full ccolumn-items w-full"
  >
    <slot />
  </section>
</template>

<script>
export default {
  name: 'ContentColumn',
}
</script>
